var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8319 14.6813L9.31763 9.16705L14.0447 5.22818L18.7712 9.95473L14.8319 14.6813Z",
    fill: "#BE1931"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3461 9.95473C19.4763 10.8255 18.0656 10.8255 17.1959 9.95473L14.0447 6.80403C13.1739 5.93426 13.1739 4.52259 14.0447 3.65232C14.9139 2.78256 16.3251 2.78256 17.1959 3.65232L20.3461 6.80403C21.2163 7.67379 21.2163 9.08496 20.3461 9.95473Z",
    fill: "#DD2E44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97135 11.9244C9.97135 11.9244 2.62191 20.5898 3.01524 20.9847C3.40908 21.379 12.075 14.0281 12.075 14.0281L9.97135 11.9244Z",
    fill: "#99AAB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6195 17.0453C14.7502 17.9161 13.3391 17.9161 12.4678 17.0453L6.95408 11.5306C6.08432 10.6603 6.08432 9.25016 6.95408 8.37989C7.82435 7.50911 9.23552 7.50911 10.1058 8.37989L15.6195 13.8941C16.4898 14.7649 16.4898 16.1745 15.6195 17.0453Z",
    fill: "#DD2E44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon-pin.be79cd70c1d32af4a75f2a4015161abb.svg";
export { ForwardRef as ReactComponent };